import type { JSX } from 'react';
import './DownloadDetailedTable.scss';

export const DownloadDetailedTable = ({
  artifactName,
  tableData,
}: {
  artifactName: string;
  tableData: JSX.Element[];
}) => (
  <div
    className="download-detailed-table"
    data-testid="download-detailed-table"
  >
    <div className="download-detailed-table__header">
      <h2 className="download-detailed-table__header-text">Releases</h2>
    </div>
    <table className="download-detailed-table__container">
      <caption className="download-detailed-table__caption">
        Releases for {artifactName}
      </caption>
      <thead className="download-detailed-table__head-container">
        <tr className="download-detailed-table__head-row">
          <th scope="col" className="download-detailed-table__head-row-item">
            <div className="download-detailed-table__head-row-item-text">
              Version
            </div>
          </th>
          <th scope="col" className="download-detailed-table__head-row-item">
            <div className="download-detailed-table__head-row-item-text">
              Maintenance status
            </div>
          </th>
          <th scope="col" className="download-detailed-table__head-row-item">
            <div className="download-detailed-table__head-row-item-text">
              Release date
            </div>
          </th>
          <th scope="col" className="download-detailed-table__head-row-item">
            <div className="download-detailed-table__head-row-item-text">
              Size
            </div>
          </th>
        </tr>
      </thead>
      <tbody>{tableData}</tbody>
    </table>
  </div>
);
